import React from 'react';
import InlineSvg from './InlineSvg';

const LineyLesson = () => {
  return (
    <div className="liney-lesson-indicator">
      <InlineSvg name="liney-icon" />
      <h4 className="liney-lesson-indicator__heading">Liney Lesson</h4>
    </div>
  );
};

export default LineyLesson;
